/**
 * CSS media query helper
 */

type BreakpointsConfig = {[key: string]: string | number};

const DEFAULT_BREAKPOINTS: BreakpointsConfig = {
  phone: '@media only screen and (min-width: 320px) and (max-width: 767px)',
  phoneAndUp: 320,
  tablet: '@media only screen and (min-width: 768px) and (max-width: 1024px)',
  tabletAndUp: 768,
  laptop: '@media only screen and (min-width: 1025px) and (max-width: 1599px)',
  laptopAndUp: 1025,
  desktop: 1600
};

export default function(bpName: string, bpConfig: BreakpointsConfig = DEFAULT_BREAKPOINTS): string {
  const x = bpConfig[bpName];
  return typeof x === 'number' ? `@media only screen and (min-width: ${x}px)` : x;
}



// WEBPACK FOOTER //
// ./src/utils/mq.ts